import Setting from '@yichui/js-contrib/src/setting';
import Request from './request';
import Utils from './utils';
import User from './user';
import Cms from './cms';
import Wallet from './wallet';
import Msg from './msg';
import Mall from './mall';
import Mobile from './components/mobile';

export { Setting, Request, Utils, Mobile, User, Cms, Wallet, Msg, Mall };

// module.exports = {
//   Setting,
// };
